module.exports = __webpack_public_path__ + "static/media/Niveau_elN4_1_633272.056e4b90.png";